export const initialState = {
  documentTypeXProperty: {
    documentTypeId: null,
    propertyId: null,
    propertyCode: '',
    propertyName: '',
    propertyTypeId: null,
    mandatory: false,
    defaultValue: null,
    implicit: false,
    orderNo: null,
    saving: false,
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'onInitState':
      return onInitState(state, action);
    case 'onHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'onHeaderSaved':
      return onHeaderSaved(state, action);
    case 'onHeaderSaveStarted':
      return onHeaderSaveStarted(state, action);
    case 'onHeaderSaveFailed':
      return onHeaderSaveFailed(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  // eslint-disable-next-line no-unused-vars
  const { states, documentTypeId, ...docTypeXProperty } = action.data;
  return {
    ...state,
    documentTypeXProperty: { ...state.documentTypeXProperty, ...docTypeXProperty, documentTypeId, changed: false }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  return {
    ...state,
    documentTypeXProperty: {
      ...state.documentTypeXProperty,
      [propertyName]: value,
      changed: true
    }
  };
}

function onHeaderSaved(state) {
  return {
    ...state,
    documentTypeXProperty: {
      ...state.documentTypeXProperty,
      changed: false,
      saving: false
    }
  };
}

const onHeaderSaveStarted = state => {
  return {
    ...state,
    documentTypeXProperty: {
      ...state.documentTypeXProperty,
      saving: true
    }
  };
};

const onHeaderSaveFailed = state => {
  return {
    ...state,
    documentTypeXProperty: {
      ...state.documentTypeXProperty,
      saving: false
    }
  };
};
